<template>
  <div class="moz-rating">
    <span
      v-if="rating"
      class="star on"
    >
      {{ starRepeat(rating) }}
    </span>
    <span
      v-if="rating < 5"
      class="star off"
    >
      {{ starRepeat(5 - rating) }}
    </span>
  </div>
</template>

<script>
const START_SYMBOL = '★';

export default {
  name: 'RatingStar',
  props: {
    rating: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    starRepeat(count) {
      return [...Array(count)].map(() => START_SYMBOL).join('');
    },
  },
};
</script>

<style lang="scss" scoped>
  .moz-rating {
    display: inline-block;

    .star {
      font-size: 13px;
      display: inline-block;
      letter-spacing: 3px;
    }

    .on {
      color: #fcc710;
    }

    .off {
      color: #e8e8e8;
    }
  }
</style>
